import React from 'react';
import withIcon from '../utilities/withIcon';

const IconBalloon = () => {
  return (
    <g>
      <path d="m4.5237 3.1748a2.4426 2.4426 0 0 0 -1.42 2.5727.7.7 0 0 0 .6983.6611l.04-.0015a.7.7 0 0 0 .66-.7378c-.05-.9038.4438-1.1528.5117-1.1831a.7.7 0 0 0 -.4888-1.3115z" />
      <path d="m15.4441 14.4673c-1.5093-1.8726-4.6255-.7515-6.1226-.2119a1.9249 1.9249 0 0 1 -1.5532-.0264 1.6173 1.6173 0 0 1 -.54-.458h.4779a.7.7 0 0 0 .6748-.8867l-.4623-1.6717a5.7087 5.7087 0 1 0 -3.6393 0l-.4623 1.6716a.7.7 0 0 0 .6748.8867h1.05a3.2844 3.2844 0 0 0 1.5461 1.7944 3.1557 3.1557 0 0 0 1.44.3369 3.852 3.852 0 0 0 1.3022-.2358c1.08-.3887 3.6084-1.3 4.4468-.2578a.75.75 0 1 0 1.1679-.9414zm-13.5541-8.6612a4.2087 4.2087 0 1 1 4.2085 4.209 4.213 4.213 0 0 1 -4.2085-4.209zm4.2085 5.709c.15 0 .2974-.0111.4446-.0225l.2429.878h-1.3746l.2429-.878c.1471.0114.2942.0225.4441.0225z" />
    </g>
  );
};

export default withIcon(IconBalloon);
